import React, {useEffect, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import {useBuildingService} from "../../services/building-service";
import InitialLoading from "../../components/initial-loading";
import {useParams} from "react-router-dom";
import {AppEvents, AttachmentTypes, BuildingOwnershipTypes, BuildingStatTypes} from "../../utils/constants";
import BuildingStatWidgetContent from "../../components/buildings/building-stat-widget-content";
import Manager from "../../components/buildings/manager";
import Article from "../../components/articles/article";
import Attachments from "../../components/attachments/attachments";
import BuildingStatShareWidget from "../../components/buildings/building-stat-share-widget";
import {getPersistedDisplayUsers} from "../../utils/auth";
import {useEventsService} from "../../services/events-service";


export default function BuildingPortfolioDetail () {
  const buildingService = useBuildingService();
  const eventsService = useEventsService();

  const params = useParams();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [loaded, setLoaded] = useState(false);
  const [building, setBuilding] = useState(null);
  const [cover, setCover] = useState(null);
  const [map, setMap] = useState(null);
  const [displayUsers, setDisplayUsers] = useState(getPersistedDisplayUsers());

  useEffect(() => {
    eventsService.on(AppEvents.displayUsersChanged, (event) => {
      setDisplayUsers(getPersistedDisplayUsers());
    })
  }, []);

  useEffect(()=>{
      loadDetailData(params.id);
  }, [params.id, displayUsers]);

  const loadDetailData = (id)=>{
    if (!id){
      id = params.id;
    }
    if (!id){
      setBuilding(null);
      setLoaded(true);
      return;
    }
    let promises = [
      buildingService.getPortfolioDetail(id),
    ];

    Promise.all(promises)
      .then(([detail= {}])=>{
        let ci = HelperService.getObjByKey(detail.attachments, 'attachment_type_id', AttachmentTypes.cover.val);
        setCover(ci ? ci : null);
        let mi = HelperService.getObjByKey(detail.attachments, 'attachment_type_id', AttachmentTypes.buildingMap.val);
        setMap(mi ? mi : null);

        setBuilding(detail);

        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať detail.");
      });
  }

  return (
    <>

      {!loaded && <InitialLoading />}

      {loaded && <Section animation={HelperService.getRandomAnimation()}>
        <div className="container">
          <div className="row">

            <div className="d-flex align-items-center justify-content-between mb-2">
              <PageTitle>{building?.title ? building.title : 'Detail nehnuteľnosti'}</PageTitle>
            </div>

            {!building?.id && <InitialLoading />}

            {building?.id && <>

              <Section animation={HelperService.getRandomAnimation()}>
                <div className="col-12">
                  <div className="card h-100 p-relative mb-0">
                    <div className='row'>
                      <div className='col-sm-12 col-md-6'>
                        {cover && <img src={cover?.url} className="w-100 rounded-start" alt="" />}
                      </div>
                      <div className='col-sm-12 col-md-6'>
                        <div className="card-body">
                          <h3>{building.title}</h3>
                          <span className={`building-portfolio-badge badge badge-lg bg-${HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', building.ownership_type).color}`}>
              {HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', building.ownership_type).title}</span>
                          <p className="card-text my-2" style={{maxHeight: '230px'}}>{building.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Section>

              <Section animation={HelperService.getRandomAnimation()}>
                <h2>Lokalita</h2>
                <div className="col-12 mt-2">
                  <div className="card h-100 p-relative mb-0">
                        <div className='map-box' style={{height: '320px', backgroundImage: map?.url ? `url(${map?.url})` : 'none'}}>
                          <a target="_blank" className="d-inline-block" href={building.addresses ? `https://www.google.com/maps/search/?api=1&query=${building.addresses[0]?.street} ${building.addresses[0]?.street_number}, ${building.addresses[0]?.city}, ${building.addresses[0]?.country?.title}` : '#'}><div className='pin'></div></a>
                          {/*{map && <img src={map?.url} alt="" />}*/}
                        </div>
                  </div>
                </div>
              </Section>

              <Section animation={HelperService.getRandomAnimation()}>
                <h2>Novinky</h2>
                <div className="row">
                  {!building?.articles?.length>0 && <div className="card"><div className="card-body"><p className="text-muted text-center">Zatiaľ prázdne :)</p></div></div>}
                  {building?.articles?.length>0 &&
                    building.articles.map((art)=>{
                      return <div key={art.id} className="col-sm-12 col-md-6 col-lg-4"><Article article={art} /></div>;
                    })
                  }
                </div>
              </Section>

              <Section animation={HelperService.getRandomAnimation()}>
                <h2>Finančné údaje</h2>
                <div className="col-12">
                  <div className="card h-100 p-relative mb-0 overflow-hidden">
                    <div className='row g-0'>
                      <BuildingStatShareWidget shares={building?.shares} containerClass={"col-sm-6 col-lg-2"} widgetClass={'building-portfolio-row-card'} />
                      <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacity.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-2"} widgetClass={'building-portfolio-row-card'}
                                                 second={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityReserved.val)}
                                                 third={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityAccepted.val)}
                                                 fourth={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityFree.val)} />
                      <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.parkingPlaces.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-2 bg-success text-white"} widgetClass={'building-portfolio-row-card border-0'} />
                      <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.repairFund.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-2 bg-indigo text-white"} widgetClass={'building-portfolio-row-card border-0'} />
                      <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.rent.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-4"} widgetClass={'building-portfolio-row-card'} />
                      <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.profit.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-4"} widgetClass={'building-portfolio-row-card'} />
                      <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.lentArea.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-2"} widgetClass={'building-portfolio-row-card'} />
                      <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.buildingValue.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-4"} widgetClass={'building-portfolio-row-card'} />
                    </div>
                  </div>
                </div>
              </Section>

              <Section animation={HelperService.getRandomAnimation()}>
                <h2>Dokumenty</h2>
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      {!building?.attachments?.length>0 &&
                        <div className="card-body text-center">
                          <p className="text-muted">Zatiaľ prázdne :)</p>
                        </div>}
                      {building?.attachments?.length>0 && <Attachments attachments={building.attachments} />}
                    </div>
                  </div>
                </div>
              </Section>

              <Section animation={HelperService.getRandomAnimation()}>
                <h2>Správcovia</h2>
                <div className="col-12">
                  <div className="row">
                    {!building?.managers.length>0 && <div className="card">
                      <div className="card-body">
                        <p className="text-muted">Zatiaľ prázdne :)</p>
                      </div>
                    </div>}
                    {building?.managers.length>0 && building.managers.map((man, i)=>{
                      return <div key={man.id} className={`col-sm-12 col-md-6 col-lg-4`}><Manager manager={man} className={i===1 ? 'bg-success text-white' : null} /></div>;
                    })}
                  </div>
                </div>
              </Section>

            </>}

          </div>
        </div>
      </Section>}

    </>
  );
}

BuildingPortfolioDetail.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

BuildingPortfolioDetail.getSEO = function getSEO() {
  return {
    title: "Detail budovy",
  }
}
